// extracted by mini-css-extract-plugin
export default {"main":"styles_main__0ci9C","blue1":"styles_blue1__5NgbP","blue2":"styles_blue2__hfiBE","blue3":"styles_blue3__4CEZu","white":"styles_white__nF-Rk","grey":"styles_grey__tJeyW"};